import form from '../../scripts/form';
import addClass from '../../scripts/util/DOM/addClass';
import qs from '../../scripts/util/DOM/qs';
import bindEvent from '../../scripts/util/bindEvent';
import $ from 'jquery';


const selectors = {
	body: 'body',
	vacancies: '.vacancies',
	formClose: '.vacancy-form__form-close',
	formOpen: '.vacancy-card__mobile-button',
	formBlock: '.vacancy-card__left',
	page: '.page',
	popup: '.vacancies__popup',
	thankBlockName: '.vacancy-thank .heading__title span',
	thankBlockVacancy: '.vacancy-thank .heading__text span',
	input: '.vacancy-form .js-field-input'
};

const classes = {
	success: 'vacancies_hide_group',
	animate: 'vacancies_hide_animate',
	hide: 'vacancies__popup_hide',
	show: 'vacancies__popup_show',
	noscroll: 'noscroll',
	formOpen: 'vacancy-card__left_open',
	bodyhidden: 'body_hidden',
	pageHidden: 'page_state_hidden'
};

const vacancies = qs(selectors.vacancies);
const page = qs(selectors.page);
const popup = qs(selectors.popup);
let scrollPosition;

const removeCls = (cls, elem) => {
	elem.classList.remove(classes[cls]);
};

const hideForm = () => {
	$(selectors.page).removeClass(classes.pageHidden);
	$(window).scrollTop(scrollPosition);
	removeCls('noscroll', page);
	removeCls('show', popup);
	removeCls('hide', popup);
	$(selectors.body).removeClass(classes.bodyhidden);
};

const closeForm = e => {
	e.stopPropagation();
	addClass(classes.hide)(popup);
	setTimeout(hideForm, 500);
};

const openForm = e => {
	e.stopPropagation();
	const vacancy = $(e.currentTarget).parent().find('input[name="input-vacancy"]').val();
	scrollPosition = $(window).scrollTop();
	$(popup).find('input[name="input-vacancy"]').val(vacancy);
	$(popup).addClass(classes.show);
	$(selectors.page).addClass(classes.noscroll);
	$(selectors.page).addClass(classes.pageHidden);
	$(selectors.body).addClass(classes.bodyhidden);
};

const scrollToThankBlock = () => {
	$('html, body').animate({
		scrollTop: $('.vacancy-thank').offset().top - 70
	}, 1000);
};

const success = res => {
	addClass(classes.animate)(vacancies);
	addClass(classes.hide)(popup);
	setTimeout(hideForm, 500);

	$(selectors.thankBlockName).text(res.name);
	$(selectors.thankBlockVacancy).text(res.vacancy);

	setTimeout(() => {
		addClass(classes.success)(vacancies);
		scrollToThankBlock();
	}, 500);
};

const hidePlaceholders = () => {
	$(selectors.input).focus( function () {
		$(this).data('placeholder', $(this).attr('placeholder'));
		$(this).attr('placeholder', '');
	});
	$(selectors.input).blur( function () {
		$(this).attr('placeholder', $(this).data('placeholder'));
	});
};

const render = formBlock => {
	form(formBlock, success, '/vacancies/send');
	bindEvent(selectors.formClose, 'click', closeForm);
	bindEvent(selectors.formOpen, 'click', openForm);
	hidePlaceholders();
};

export default render;


